<div class="row mb-3">
    <div class="col-md-1">
        <app-audit-module-add [isEditMode]="isEditMode"
                              [auditId]="auditId"
                              (auditModuleAdded)="onAuditModuleAdded($event)">
        </app-audit-module-add>
    </div>
</div>

<section class="panel">
    <div class="panel-body">
        <div class="table-responsive">
            <table class="table table-hover mb-none">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Module Name</th>
                        <th>Audit Type</th>
                        <th>Order</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let auditModule of auditModules;index as i">
                        <td>{{i+1}}</td>
                        <td>{{auditModule.moduleName}}</td>
                        <td>{{auditModule.auditType}}</td>
                        <td>{{auditModule.order}}</td>
                        <td class="actions">
                            <a (click)="selectedModuleId=auditModule.moduleId; confirmation.showMessage()" title="Delete Module" class="mb-1 mt-1 mr-2"><i class="fas fa-trash"></i></a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</section>

<app-confirmation-message #confirmation (confirmationClicked)="deleteAuditModules()"
                          [title]="'Confirmation'"
                          [message]="'Are you sure you want to remove this module?'">
</app-confirmation-message>
